import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

export const getAllTransactions = async (
  eventId,
  pageNumber = 1,
  pageSize = 1000
) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      //`${apiendpoints.GET_PAYMENTS}?eventId=${eventId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
      `${apiendpoints.GET_PAYMENTS}?eventId=${eventId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// Reports Organizer Transtions
export const getAllOrganizerPaymentReports = async (
  userId,
  eventId,
  pageNumber = 1,
  pageSize = 1000
) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      // `${apiendpoints.MANAGE_ORGANIZER_TRANSTION_REPORT}?userId=${userId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
      `${apiendpoints.MANAGE_ORGANIZER_TRANSTION_REPORT}?userId=${userId}&eventId=${eventId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// Reports Trader Transtions
export const getAllTraderPaymentReports = async (
  userId,
  eventId,
  pageNumber = 1,
  pageSize = 1000
) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      //`${apiendpoints.MANAGE_TRADER_TRANSION_REPORT}?userId=${userId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
      `${apiendpoints.MANAGE_TRADER_TRANSION_REPORT}?userId=${userId}&eventId=${eventId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// Reports Organizer Transtions
export const getEventPitchSaleSummaryReports = async (
  eventId,
  pageNumber = 1,
  pageSize = 1000
) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      // `${apiendpoints.MANAGE_ORGANIZER_TRANSTION_REPORT}?userId=${userId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
      `${apiendpoints.MANAGE_EVENT_PITCH_SALE_REPORT}?&eventId=${eventId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// Reports Organizer Transtions
export const getEOEventPitchSaleSummaryReports = async (
  userId,
  eventId,
  pageNumber = 1,
  pageSize = 1000
) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      // `${apiendpoints.MANAGE_ORGANIZER_TRANSTION_REPORT}?userId=${userId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
      `${apiendpoints.MANAGE_EO_EVENT_PITCH_SALE_REPORT}?userId=${userId}&eventId=${eventId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
